"use strict";

exports.__esModule = true;
exports.getToolboxOptions = exports.dataViewTable = void 0;
var _constants = require("../../constants");
var getToolboxOptions = exports.getToolboxOptions = function getToolboxOptions(toolbox, translate, downloadCSVData, tableData) {
  var _toolbox$dataView, _toolbox$downloadData, _toolbox$magicType, _toolbox$saveAsImage, _toolbox$dataView2, _toolbox$saveAsImage2, _toolbox$magicType2, _toolbox$magicType3, _toolbox$downloadData2;
  return {
    z: 11,
    show: toolbox == null ? void 0 : toolbox.show,
    orient: (toolbox == null ? void 0 : toolbox.orientation) || _constants.ORIENTATION_VERTICAL,
    itemSize: 20,
    itemGap: 14,
    showTitle: true,
    backgroundColor: 'rgba(220,220,220,0.4)',
    emphasis: {
      iconStyle: {
        textBackgroundColor: 'rgba(220,220,220,0.4)',
        textPadding: 5
      }
    },
    dataView: {
      show: (toolbox == null || (_toolbox$dataView = toolbox.dataView) == null ? void 0 : _toolbox$dataView.show) || false
    },
    downloadData: {
      show: (toolbox == null || (_toolbox$downloadData = toolbox.downloadData) == null ? void 0 : _toolbox$downloadData.show) || false
    },
    magicType: {
      types: (toolbox == null || (_toolbox$magicType = toolbox.magicType) == null ? void 0 : _toolbox$magicType.types) || []
    },
    saveAsImage: {
      show: (toolbox == null || (_toolbox$saveAsImage = toolbox.saveAsImage) == null ? void 0 : _toolbox$saveAsImage.show) || false
    },
    orientation: (toolbox == null ? void 0 : toolbox.orientation) || "vertical",
    feature: {
      dataZoom: {
        yAxisIndex: "none"
      },
      dataView: {
        show: (toolbox == null || (_toolbox$dataView2 = toolbox.dataView) == null ? void 0 : _toolbox$dataView2.show) || false,
        readOnly: true,
        optionToContent: function optionToContent() {
          return dataViewTable(tableData);
        }
      },
      restore: {},
      saveAsImage: {
        show: (toolbox == null || (_toolbox$saveAsImage2 = toolbox.saveAsImage) == null ? void 0 : _toolbox$saveAsImage2.show) || false
      },
      magicType: {
        show: (toolbox == null || (_toolbox$magicType2 = toolbox.magicType) == null ? void 0 : _toolbox$magicType2.show) || false,
        type: (toolbox == null || (_toolbox$magicType3 = toolbox.magicType) == null ? void 0 : _toolbox$magicType3.types) || []
      },
      myDownloadData: {
        show: (toolbox == null || (_toolbox$downloadData2 = toolbox.downloadData) == null ? void 0 : _toolbox$downloadData2.show) || false,
        title: translate("ComponentLifetimeChart.toolbox.Info", "Download as csv"),
        icon: "path://M 10 0 C 4.48 0 0 4.48 0 10 s 4.48 10 10 10 s 10 -4.48 10 -10 S 15.52 0 10 0 Z m 4.71 11.71 l -4 4 c -0.18 0.18 -0.43 0.29 -0.71 0.29 s -0.53 -0.11 -0.71 -0.29 l -4 -4 a 1.003 1.003 0 0 1 1.42 -1.42 L 9 12.59 V 5 c 0 -0.55 0.45 -1 1 -1 s 1 0.45 1 1 v 7.59 l 2.29 -2.29 c 0.18 -0.19 0.43 -0.3 0.71 -0.3 a 1.003 1.003 0 0 1 0.71 1.71 Z",
        onclick: function onclick() {
          downloadCSVData();
        }
      }
    }
  };
};
var dataViewTable = exports.dataViewTable = function dataViewTable(data) {
  if (!Array.isArray(data)) {
    data = [];
  }
  var table = '<div style="width:100%;display: table">';
  var timeHeaderName = "Time";
  var tableRowStyle = "style=\"border: 1px solid #dddddd; text-align: left; padding: 10px;\"";
  data.forEach(function (d) {
    table += "<div style=\"display: table-cell; padding: 5px\">";
    table += '<table style="width:100%;border-collapse: collapse;"><tbody>';
    table += "<tr>";
    table += "<th " + tableRowStyle + ">" + timeHeaderName + "</th>";
    table += "<th " + tableRowStyle + ">" + d.name + "</th>";
    table += "</tr>";
    d.values.forEach(function (v) {
      table += "<tr>";
      table += "<td " + tableRowStyle + ">" + v.timestamp + "</td>";
      table += "<td " + tableRowStyle + ">" + v.value + "</td>";
      table += "</tr>";
    });
    table += "</tbody></table>";
    table += "</div>";
  });
  table += "</div>";
  return table;
};